import React from 'react';
import Icon from './Icon';

export default function TagChip({ children, active = false, subtle = false, size = 'md', icon, onClick, href }) {
    const padY = size === 'sm' ? 4 : 6;
    const padX = size === 'sm' ? 10 : 13;
    const fz   = size === 'sm' ? 11 : 12.5;
    const Element = href ? 'a' : 'button';

    return (
        <Element
            href={href}
            type={href ? undefined : 'button'}
            onClick={onClick}
            style={{
                padding: `${padY}px ${padX}px`,
                background: active ? '#e60073' : subtle ? 'transparent' : '#171719',
                color: active ? '#fff' : subtle ? '#A1A1AA' : '#E4E4E7',
                border: `1px solid ${active ? 'transparent' : '#27272A'}`,
                borderRadius: 999,
                fontSize: fz, fontWeight: active ? 600 : 500,
                whiteSpace: 'nowrap', cursor: 'pointer',
                fontFamily: "'Manrope', sans-serif",
                transition: 'background 120ms, color 120ms',
                textDecoration: 'none',
                display: 'inline-flex', alignItems: 'center', gap: 6,
            }}
        >
            {icon && <Icon name={icon} size={fz + 1} stroke={2} color={active ? '#fff' : '#e60073'} />}
            {children}
        </Element>
    );
}
